var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    { staticClass: "dd-right", attrs: { right: "" } },
    [
      _c(
        "template",
        { slot: "button-content" },
        [
          _c("v-gravatar", {
            staticClass: "img-avatar",
            attrs: { email: _vm.currentUserEmail, alt: _vm.currentUserEmail }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.currentUserEmail.split("@")[0]))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("b-dropdown-item", { attrs: { to: "/profile" } }, [
        _c("div", {
          staticClass: "dd-icon",
          domProps: { innerHTML: _vm._s(_vm.svg.ddUser) }
        }),
        _c("span", { staticClass: "dd-text" }, [
          _vm._v(" " + _vm._s(_vm.$t("HEADER.PROFILE")))
        ])
      ]),
      _vm._v(" "),
      _vm.isSuperAdmin
        ? _c("b-dropdown-item", { attrs: { to: "/super_admin/accounts" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.ddAccounts) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(" " + _vm._s(_vm.$t("HEADER.ACCOUNTS")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSuperAdmin
        ? _c("b-dropdown-item", { attrs: { to: "/super_admin/features" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.featureflag) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(" " + _vm._s(_vm.$t("HEADER.Features")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSuperAdmin
        ? _c("b-dropdown-item", { attrs: { to: "/super_admin/models" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.ddModels) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(" " + _vm._s(_vm.$t("HEADER.MODELS")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdminRole
        ? _c("b-dropdown-item", { attrs: { to: "/admin/users" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.ddAdmin) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(_vm._s(_vm.$t("HEADER.USERS")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdminRole
        ? _c("b-dropdown-item", { attrs: { to: "/audits/trail" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.history) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(_vm._s(_vm.$t("HEADER.LOGS")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdminRole
        ? _c("b-dropdown-item", { attrs: { to: "/settings/configure" } }, [
            _c("div", {
              staticClass: "dd-icon",
              domProps: { innerHTML: _vm._s(_vm.svg.ddSettings) }
            }),
            _c("span", { staticClass: "dd-text" }, [
              _vm._v(_vm._s(_vm.$t("HEADER.SETTINGS")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("b-dropdown-item", { on: { click: _vm.logOut } }, [
        _c("div", {
          staticClass: "dd-icon",
          domProps: { innerHTML: _vm._s(_vm.svg.ddLogout) }
        }),
        _c("span", { staticClass: "dd-text" }, [
          _vm._v(_vm._s(_vm.$t("HEADER.LOGOUT")))
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a8c5ef7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8c5ef7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownAccnt.vue
// module id = 947
// module chunks = 2